import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, EventTriggers, Money, RequiredValidator } from '../../Components/Form';
import { eventTriggers } from '../../Data/Misc';

const EditEstimate = ({estimate, save, onSave, isOpen, setIsOpen}) => {
    return <Modal title="Simple Estimate" isOpen={isOpen} setIsOpen={setIsOpen}>
        <Inner {...{estimate, save, onSave}} />
    </Modal>
}

const Inner = ({estimate, save, onSave}) => {
    const handleSave = (data) => {
        if (data.upper === 0) {
            delete data.upper;
        }
        return save(data);
    }
    return <Form onSubmit={handleSave} data={estimate} afterSubmit={onSave} closeModalOnSubmit>
        <Money name="lower" label="Lower estimate" validators={[RequiredValidator]} />
        <Money name="upper" label="Upper estimate" help="Leave blank to provide a fixed price estimate" />
        <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
        <Actions submit cancel />
    </Form>;
}


export default EditEstimate;
